import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { map, isEmpty } from 'lodash';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';
import OGCTabs from '../../components/OGCTabs';
import OGCFeaturesTabs from '../../components/OGCFeaturesTabs';
import ModalElement from '../../components/ModalElement';
import loadGeoJSONFromURL from '../../../modules/load-geojson-from-url';

let domainWithoutLastSlash = '';
const NewDBOGCAPI = props => {
  const { gmsConnections, isPremium, isAdmin } = props;
  const [collections, setCollections] = React.useState({});
  const [features, setFeatures] = React.useState([]);
  const [IdDomaind, setIdDomaind] = React.useState('');
  const [modalShow, setModalShow] = React.useState(false);
  const inputDomain = React.useRef('');
  const [activeTab, setActiveTab] = React.useState('collection0');
  const [loadingCAT, setLoadingCAT] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [offset, setOffset] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  const loadCollection = async indexUrlFile => {
    setFeatures([]);
    setCollections([]);
    domainWithoutLastSlash = indexUrlFile;
    if (indexUrlFile.charAt(indexUrlFile.length - 1) === '/') {
      domainWithoutLastSlash = indexUrlFile.substr(0, indexUrlFile.length - 1);
    }

    const data = await loadGeoJSONFromURL(`${domainWithoutLastSlash}/collections?f=json`);

    setCollections([data.collections]);
    setActiveTab('collection0');
  };

  const loadSubCollection = async (id, Search) => {
    if (id !== IdDomaind) {
      if (id !== '') {
        setLoadingCAT(true);
        setFeatures([]);
        setIdDomaind(id);
        setCurrentPage(1);
        setOffset(0);
      }

      const usedId = isEmpty(id) ? IdDomaind : id;
      const data = await loadGeoJSONFromURL(
        `${domainWithoutLastSlash}/collections/${usedId}/items?f=json${Search}`
      );

      if (isEmpty(data.collection) && !isEmpty(data.features)) {
        setFeatures(data.features);
      } else setCollections([...collections, data.collections]);
      setLoadingCAT(false);
    }
  };
  const updateSubCollection = async Search => {
    const data = await loadGeoJSONFromURL(
      `${domainWithoutLastSlash}/collections/${IdDomaind}/items?f=json&${Search}`
    );

    if (isEmpty(data.collection) && !isEmpty(data.features)) {
      setFeatures(data.features);
    } else setCollections([...collections, data.collections]);
    setLoadingCAT(false);
  };

  const handleOnChangeServerList = evt => {
    const domain = evt.target.value;
    loadCollection(domain);
  };

  const redirectToLayerView = () => {
    // Bert.alert(confirmation, 'success');
    window.open('/layers/new', '_self');
  };

  const redirectToLayerViewTab = () => {
    window.open('/layers/new', '_blank');
  };

  const loadDataToSource = data => {
    localStorage.setItem('Metadata', JSON.stringify(data));
    redirectToLayerView(data);
  };
  const loadLocalStorage = (data, isModal) => {
    localStorage.setItem('Metadata', JSON.stringify(data));
    if (!isModal) {
      redirectToLayerViewTab();
    } else {
      setModalShow(true);
    }
  };
  const loadLayer = async (id, but) => {
    const subtype = 'GeoJSON';
    const details = {
      url: `${domainWithoutLastSlash}/collections/${IdDomaind}/items/${id}?f=json`,
      subtype,
      isFeature: false
    };

    if (but === 'PUSH') {
      loadDataToSource(details);
    } else if (but === 'TAB') {
      details.isModal = false;
      loadLocalStorage(details, false);
    } else if (but === 'Modal') {
      details.isModal = true;
      loadLocalStorage(details, true);
    }
  };
  const loadLayerCollection = async (id, value, but) => {
    const subtype = 'GeoJSON';
    const details = {
      url: `${domainWithoutLastSlash}/collections/${id}/items?f=json&startindex=${offset *
        value}&limit=${value}`,
      subtype,
      isFeature: false
    };

    if (but === 'PUSH') {
      loadDataToSource(details);
    } else if (but === 'TAB') {
      details.isModal = false;
      loadLocalStorage(details, false);
    } else if (but === 'Modal') {
      details.isModal = true;
      loadLocalStorage(details, true);
    }
  };

  React.useEffect(() => {}, [collections]);

  return (
    <>
      <Row>
        <Col xs={6}>
          <div className="row">
            <div className="col-12">
              <h4>OGC API Features</h4>
              <Form.Group>
                <Form.Control
                  as="select"
                  name="gmsConnection"
                  onChange={event => handleOnChangeServerList(event)}
                >
                  <option value="">-</option>
                  {map(gmsConnections, ({ _id, name, serverType, domain }) => {
                    if (serverType === 'OGC-API-Features')
                      return (
                        <option value={domain} key={_id}>
                          {name}
                        </option>
                      );
                    return '';
                  })}
                </Form.Control>
              </Form.Group>
            </div>
          </div>
          {(isAdmin || isPremium) && (
            <div className="row">
              <div className="col-10">
                <Form.Control
                  ref={inputDomain}
                  name="DTL-URL"
                  defaultValue="Database Tile Server URL"
                />
              </div>
              <div className="col-2">
                <Button
                  block
                  onClick={() => {
                    loadCollection(inputDomain.current.value);
                  }}
                >
                  Load URL
                </Button>
              </div>
            </div>
          )}
        </Col>
        {isEmpty(collections) ? (
          false
        ) : (
          <Col xs={6}>
            <Tabs id="controlled-tab" activeKey={activeTab} onSelect={k => setActiveTab(k)}>
              {map(collections, (collection, index) => {
                return (
                  <Tab
                    eventKey={`collection${index}`}
                    key={`collection${index}`}
                    title="Collection"
                  >
                    <OGCTabs
                      collections={collection}
                      loadSubCollection={loadSubCollection}
                      loadingCAT={loadingCAT}
                      loadLayer={loadLayerCollection}
                      modalShow={modalShow}
                      setModalShow={setModalShow}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      loading={loading}
                      setLoading={setLoading}
                      offset={offset}
                      setOffset={setOffset}
                      domainWithoutLastSlash={domainWithoutLastSlash}
                    />
                  </Tab>
                );
              })}
              {isEmpty(features) ? (
                false
              ) : (
                <Tab eventKey="Features" title="Features">
                  <OGCFeaturesTabs
                    domainWithoutLastSlash={domainWithoutLastSlash}
                    IdDomaind={IdDomaind}
                    collections={features}
                    updateSubCollection={updateSubCollection}
                    loadSubCollection={loadSubCollection}
                    loadLayer={loadLayer}
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    loading={loading}
                    setLoading={setLoading}
                    offset={offset}
                    setOffset={setOffset}
                  />
                </Tab>
              )}
            </Tabs>
          </Col>
        )}
      </Row>
      <ModalElement
        modalShow={modalShow}
        onHide={() => setModalShow(false)}
        Componet="New Layer"
        {...props}
      />
    </>
  );
};

NewDBOGCAPI.defaultProps = {
  gmsConnections: []
};

NewDBOGCAPI.propTypes = {
  gmsConnections: PropTypes.array,
  isPremium: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired
};
export default withTracker(() => {
  const gmsConnectionsSub = Meteor.isClient && Meteor.subscribe('gmsConnections');
  return {
    loading: !gmsConnectionsSub.ready(),
    gmsConnections: TelemetryConnections.find().fetch()
  };
})(NewDBOGCAPI);
